import * as React from "react"
import "../styles/mystyles.scss"
import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import IntroSection from '../components/IntroSection'
import SalesSection from '../components/SalesSection'
import PurchaseSection from '../components/PurchaseSection'
import AboutSection from '../components/AboutSection'
import ContactSection from '../components/ContactSection'
import Footer from '../components/Footer'
import { Helmet } from "react-helmet"

const IndexPage = () =>
{
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale = 1.0, 
        maximum-scale=1.0, user-scalable=no" />
      </Helmet>

      <Navbar introduction="Introductie" purchase="Inkoop" sale="Verkoop" about="Over ons" webshop="Webshop" contact="Contact" page="/" selectedCountry="netherlands" possibleCountry="united-kingdom" countryLink="/eng-index" />

      <Hero page="/" description={["Banden groothandel gespecialiseerd", <br />, "in DOT- en DEMO banden. Met wekelijks", <br />,
        "nieuwe voorraad en verzending met", <br />, "DPD door heel Europa.", <br />, <br />]} button="Lees verder" />

      <IntroSection description={["Dutch Tyres, de banden groothandel in DOT- en DEMO banden. ",
        "Een ruime voorraad met diverse A-merken en dagelijkse verzending vanaf onze opslaghal in Grave. ",
        "Wij ontvangen wekelijks nieuwe voorraad en verzenden door heel Europa. Meer info over onze voorraad? ",
        "Contact ons via: ", <a>nicky@dutchtyres.nl</a>, <br />, <br />,
        "Dutch Tyres is ontstaan vanuit het voormalige montagebedrijf Bandenservice P. van Raay. ",
        "Na 40 jaar auto’s in de regio van Nijmegen voorzien te hebben van nieuwe of gebruikte autobanden was de focus de laatste jaren al ",
        "steeds meer op de groothandel gekomen. Piet was al jaren actief in de bandenbranche en dochter Nicky is sinds 2016 in het bedrijf ",
        "getreden waarbij er steeds meer focus kwam op groothandel en de online verkoop van nieuwe banden. Per 2022 zijn we gestopt met de ",
        "bandenservice en enkel verdergegaan met de groothandel, Dutch Tyres."]} />

      <PurchaseSection title="Inkoop" description={["Dutch Tyres is een onafhankelijke banden groothandel. ",
        "We zijn geïnteresseerd in autobanden van alle merken en maten in nieuw, demo en DOT. ", <br />, <br />,
        "Dutch Tyres heeft een eigen opslaglocatie in Nijmegen. Alle banden die door ons aangeboden worden zijn in ons eigendom, ",
        "wij verkopen geen banden die niet in ons magazijn opgeslagen liggen. ",
        "Dit betekend dat onze schakels kort zijn en wij snel kunnen leveren. ", <br />, <br />,
        "Op zoek naar een inkoper voor uw banden? Dutch Tyres is ",
        "altijd opzoek naar nieuwe partners. Stuur een email naar ", <a>lorenzo@dutchtyres.nl</a>]} />,

      <SalesSection title="Verkoop" description={["Dutch Tyres heeft een ruim aanbod aan nieuwe banden op voorraad in zomerbanden, winterbanden, allseasonbanden en ",
        "bestelwagenbanden. Bent u op zoek naar specifieke maten of merken? Of wilt u graag wekelijks een overzicht van onze voorraad ontvangen? Neem contact met ons op. ",
        <br />, <br />, "Bestellingen die vóór 10:00 plaatsvinden worden dezelfde dag nog verzonden. ",
        "Wij versturen door heel Europa met DPD."]} />

      <AboutSection title="Over ons" description={["Ontstaan van Dutch Tyres", <br />, <br />,
        "Piet van Raay startte op 1 mei 1981 met een tankstation aan de Tweede Oude Heselaan in Nijmegen. ",
        "Na een aantal jaar ontstond daar langzaam ook een bandenhandel en bandenservice bij. ",
        "In 1993 is er na sanering van het tankstation een volledige focus gekomen op de bandenhandel en bandenservice. ", <br />, <br />,
        "Na vele jaren actief te zijn geweest als bandenservice is er de laatste jaren steeds meer focus op de groothandel gekomen. ",
        "Dochter Nicky kwam in 2016 in het bedrijf en er werd een nieuw online verkoopkanaal opgezet. ",
        "In 2021 werd het besluit genomen om volledig te stoppen met de bandenservice en enkel verder te gaan als groothandel. ",
        "In 2022 ontstond daaruit Dutch Tyres, een onafhankelijke banden groothandel met de focus op DOT- en DEMO banden."]} />

      <ContactSection intro="Neem contact met ons op" addresstitle="Adresgegevens" address={["Koninginnedijk 730", <br />, "5361CR Grave"]} email="Mailadres" />

      <Footer />
    </>
  )
}

export default IndexPage
